// Import Dependencies
import { useNavigation } from "react-router";

// Local Imports
import { NProgress } from "app/presentation/components/shared/NProgress";

// ----------------------------------------------------------------------

export function Progress() {
  const navigation = useNavigation();  

  const isLoading =
    navigation.state === "loading" &&
    navigation.formData == null &&
    !!navigation.location.pathname;

  return <NProgress isAnimating={isLoading} />;
}
